import { useState, useEffect } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import {
  FormControl,
  FormLabel,
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material';
import { useCatalogFilters } from '@/packages/courses/context/catalog-filters';
import type { FilterSchemaText } from '@/packages/courses/types/schema';

export const FilterText = ({ id, title, placeholder }: FilterSchemaText) => {
  const { params, actions } = useCatalogFilters();
  const paramValue = params[id]?.[0] ?? '';

  const [localValue, setLocalValue] = useState(paramValue);

  useEffect(() => {
    setLocalValue(paramValue);
  }, [paramValue]);

  const submitSearch = () => {
    const v = localValue.trim();
    actions.setParam(id, v ? [v] : undefined);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      submitSearch();
    }
  };

  return (
    <FormControl fullWidth>
      <FormLabel>{title}</FormLabel>
      <TextField
        size="small"
        placeholder={placeholder}
        value={localValue}
        onChange={(e) => setLocalValue(e.target.value)}
        onKeyDown={handleKeyDown}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                type="button"
                aria-label="Buscar"
                onClick={submitSearch}
                edge="end"
              >
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </FormControl>
  );
};
